<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->
  <div class="py-5">
    <v-col sm="10" cols="12" class="mx-auto">
      <v-row>
        <v-col cols="12" md="3">
          <v-card class="items-container d-flex pa-3 mb-sm-0 mb-4">
            <v-tabs vertical v-model="tab">
              <v-tab> تغییرات آخرین نسخه </v-tab>
              <v-tab class="my-2"> تاریخچه بروزرسانی‌های سامانه </v-tab>
            </v-tabs>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-tabs-items v-model="tab">
            <!-- تغییرات آخرین نسخه -->
            <v-tab-item>
              <v-card class="br-card card-container px-sm-8 px-5 pt-1 py-8">
                <h2 class="version-major">نسخه 1.0.2</h2>
                <ul
                  class="mt-2 ps-6 main-grey-text fs-medium"
                  style="line-height: 30px"
                >
                  <li class="blue-grey--text text--darken-1 font-weight-bold">
                    تاریخ انتشار: 14 مرداد 1402
                  </li>
                  <li>برطرف کردن مشکل ریسپانسیو داشبورد </li>
                </ul>
              </v-card>
            </v-tab-item>

            <!-- تاریخچه بروزرسانی‌های سامانه -->
            <v-tab-item>
              <v-card class="br-card card-container px-8 pt-1 py-8">
                <h2 class="version-major">نسخه 1.0.2</h2>
                <ul
                  class="mt-2 ps-6 main-grey-text fs-medium"
                  style="line-height: 30px"
                >
                  <li class="blue-grey--text text--darken-1 font-weight-bold">
                    تاریخ انتشار: 14 مرداد 1402
                  </li>
                  <li>برطرف کردن مشکل ریسپانسیو داشبورد </li>
                </ul>
                <h2 class="version-major">نسخه 1.0.1</h2>

                <ul
                  class="mt-2 ps-6 main-grey-text fs-medium"
                  style="line-height: 30px"
                >
                  <li class="primary--text font-weight-bold">
                    تاریخ انتشار: 11 مرداد 1402
                  </li>
                  <li>اضافه کردن خدمات </li>
                </ul>
                <ul
                  class="mt-2 ps-6 main-grey-text fs-medium"
                  style="line-height: 30px"
                >
                  <li class="primary--text font-weight-bold">
                    تاریخ انتشار: 7 مرداد 1402
                  </li>
                  <li>انتشار سامانه</li>
                </ul>
                <ul class="ps-5 fs-medium">
                  <li class="version-minor blue-grey--text text--darken-3">
                    نسخه 0.3.0
                  </li>
                  <ul class="ul-fontsize ps-5 blue-grey--text text--darken-3">
                    <li class="primary--text font-weight-bold">
                      تاریخ انتشار: 11 تیر 1402
                    </li>
                    <li>افزودن بخش محصولات</li>
                    <li>افزودن پنل مدیریتی ادمین</li>
                  </ul>
                  <li class="version-minor blue-grey--text text--darken-3">
                    نسخه 0.2.0
                  </li>
                  <ul class="ul-fontsize ps-5 blue-grey--text text--darken-3">
                    <li class="primary--text font-weight-bold">
                      تاریخ انتشار: 11 آبان 1401
                    </li>
                    <li>افزودن بخش تاریخچه و مدیریت مشارکت‌ها</li>
                    <li>افزودن بخش تجزیه‌ و تحلیل‌ها</li>
                    <li>افزودن بخش پرداختی‌های با حجم بالا</li>
                    <li>افزودن بخش خلاصه کارکرد هر کیک سهام</li>
                    <li>افزودن بخش تاریخچه صندوق مالی</li>
                    <li>قابلیت ارسال پیام به اعضای تیم توسط مدیر کیک سهام</li>
                    <li>قابیت مشاهده اعلانات</li>
                    <li>قابلیت بازیابی رمز عبور</li>
                    <li>قابلیت افزودن خودرو شخصی به‌عنوان مشارکت</li>
                    <li>قابلیت ثبت زمان به‌عنوان اضافه کار</li>
                    <li>محدود‌سازی دسترسی نقش‌های مختلف هر کیک سهام</li>
                  </ul>
                  <li class="version-minor blue-grey--text text--darken-3">
                    نسخه 0.1.0
                  </li>
                  <ul class="ul-fontsize ps-5 blue-grey--text text--darken-3">
                    <li class="primary--text font-weight-bold">
                      تاریخ انتشار: 7 شهریور 1401
                    </li>
                    <li>قابیلت ورود کاربر به سیستم</li>
                    <li>افزودن بخش تنظیمات کاربری</li>
                    <li>قابلیت افزودن کیک سهام برای هر فرد</li>
                    <li>قابیلت مشاهده لیست کیک‌های سهام کاربر</li>
                    <li>مشاهده جزیيات اعضا و نمودار‌های هر کیک سهام</li>
                    <li>قابیلت افزودن عضو به تیم</li>
                    <li>قابلیت تغییر تنظیمات کیک سهام</li>
                    <li>قابیلت تغییر تنظیمات هر عضو تیم</li>
                    <li>قابلیت افزودن مشارکت برای هر عضو تیم</li>
                    <li>قابلیت افزودن و برداشتن سرمایه</li>
                    <li>قابلیت فعال و غیر فعال کردن هر عضو تیم</li>
                  </ul>
                </ul>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      tab: null,
    };
  },
};
</script>

<style>
.version-major {
  font-weight: bold;
  font-size: 1.6rem;
  margin-top: 25px;
  color: #bf0000;
}

.version-minor {
  font-weight: bold;
  font-size: 1.2rem;
  margin-top: 10px;
  margin-right: 15px;
}

.version-minor2 {
  font-weight: bold;
  margin-top: 10px;
  margin-right: 15px;
}

.light-red {
  color: #bf0000bc !important;
}

.main-grey-text {
  color: #656a81 !important;
}
</style>
